<template>
  <EventCard
    :title="event?.title"
    :eventTypes="getEventTypes(event)"
    :thumbnail="event?.thumbnail"
    :date="getEventTerm(event?.term_start, event?.term_end)"
    :place="getEventPlace(event)"
    :tags="event?.tags"
    :link="event?.link"
    :category="event?.category?.name"
    :rectangle="rectangle"
    buttonLabel="イベント詳細を見る"
    :isFinished="isFinished"
    :isArchived="event?.isArchived"
    :isCancelable="true"
    :clickCancel="clickCancel"
  />
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import EventCard from '@/components/block/EventCard.vue'
import dayjs from 'dayjs'
import 'dayjs/locale/ja'
dayjs.locale('ja')
import {
  getEventTerm,
  getEventPlace,
  getEventTypes
} from '@/utils/commonMethods'

export default defineComponent({
  name: 'EventCardMypage',

  components: {
    EventCard
  },

  props: {
    event: Object,
    rectangle: {
      type: Boolean,
      default: false
    },
    clickCancel: Function
  },

  setup(props: any) {
    const checkFinished = () => {
      if (
        props.event.term_end &&
        dayjs().isAfter(dayjs(props.event.term_end), 'day')
      )
        return true

      return false
    }
    const isFinished = checkFinished()

    return {
      getEventTerm,
      getEventPlace,
      getEventTypes,
      isFinished
    }
  }
})
</script>
